import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'code',
        headerName: t('Mã', 'PeriodicOperation'),
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell value={params.row.name}>
                <EntityDetailButton
                    text={params.row.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.id}
                    type='DEVICE'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: 'customerName',
        headerName: 'Khách hàng',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell value={params.row.customerName}>
                <EntityDetailButton
                    text={params.row.customerName}
                    identifier={columnParams?.identifier}
                    entityId={params.row.customerId}
                    type='CUSTOMER'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: 'lastMaintenanceDate',
        headerName: 'Ngày bảo tri gần nhất',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell
                value={dateUtils.getDate(params.row.lastMaintenanceDate)}
            />
        ),
    },
    {
        field: 'performance',
        headerName: 'Hiệu suất',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) => (
            <HoverCopyCell
                value={params.row.performance?.toFixed(2) + ' %' || '-:-'}
            />
        ),
    },
    {
        field: 'runningTime',
        headerName: 'Thời gian chạy',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell
                value={params.row.runningTime + ' ' + t('giờ') || '-:-'}
            />
        ),
    },
];
